export interface PublicLoadingState {
  catalog: {
    getProductCatalogs: boolean;
    getHeadProduct: boolean;
  };

  basket: {
    getBySession: boolean;
    addProduct: boolean;
    updateQuantity: boolean;
    removeProduct: boolean;
    punchoutCheckout: boolean;
  };
}

export interface AuthLoadingState {
  auth: {
    publicLogin: boolean;
    publicValidate: boolean;
    publicLogout: boolean;
  };
}

export interface LoadingStore {
  public: PublicLoadingState;
  auth: AuthLoadingState;
}

export const initialLoadingStore: LoadingStore = {
  public: {
    catalog: {
      getProductCatalogs: false,
      getHeadProduct: false,
    },
    basket: {
      getBySession: false,
      addProduct: false,
      updateQuantity: false,
      removeProduct: false,
      punchoutCheckout: false,
    },
  },
  auth: {
    auth: {
      publicLogin: false,
      publicValidate: false,
      publicLogout: false,
    },
  },
};
